export default "__VITE_ASSET__CFimUtsx__"